import React, { useContext } from 'react';
import { IoArrowForward, IoCartOutline, IoClose } from "react-icons/io5";
import { CartContext } from "../context/CartContext";
import CartItem from './CartItem';
import { Link } from "react-router-dom";

const Cart = () => {
    const { setIsOpen, cart, total, clearCart } = useContext(CartContext);

    return (
        <div className="w-full h-full flex flex-col text-white">
            <div className="px-6 pt-6 pb-4 border-b border-white/10">
                <div className="flex items-center justify-between">
                    <div>
                        <h2 className="text-2xl font-bold tracking-tight">Корзина</h2>
                        <p className="text-sm text-white/60 mt-1">
                            {cart.length} {cart.length === 1 ? 'товар' : 'товаров'}
                        </p>
                    </div>
                    <button
                        onClick={() => setIsOpen(false)}
                        className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-white/10 transition-all group"
                    >
                        <IoClose className="text-2xl group-hover:rotate-90 transition-transform" />
                    </button>
                </div>
            </div>

            <div className="flex-1 overflow-y-auto px-6 py-4">
                {cart.length === 0 ? (
                    <div className="h-full flex flex-col items-center justify-center text-white/30">
                        <IoCartOutline className="text-8xl mb-6 animate-bounce" />
                        <p className="text-xl font-medium">Корзина пуста</p>
                        <p className="text-sm mt-2">Добавьте товары для оформления</p>
                    </div>
                ) : (
                    <div className="space-y-4">
                        {cart.map((item, i) => (
                            <div
                                key={item.id}
                                className="animate-in fade-in slide-in-from-bottom-4 duration-500"
                                style={{ animationDelay: `${i * 70}ms` }}
                            >
                                <CartItem item={item} />
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {cart.length > 0 && (
                <div className="border-t border-white/10 bg-black/30 backdrop-blur-md">
                    <div className="px-6 py-6">
                        <div className="flex justify-between text-lg mb-2">
                            <span className="text-white/70">Подытог</span>
                            <span>$ {total.toFixed(2)}</span>
                        </div>
                        <div className="flex justify-between text-2xl font-bold">
                            <span>Итого</span>
                            <span className="text-accent">$ {total.toFixed(2)}</span>
                        </div>
                        <p className="text-xs text-white/50 mt-2">Доставка рассчитывается на следующем шаге</p>
                    </div>

                    <div className="px-6 pb-8 flex flex-col gap-3">
                        <Link to="/order" className="w-full">
                            <button
                                onClick={() => setIsOpen(false)}
                                className="w-full bg-accent hover:bg-amber-500 text-white font-bold py-4 rounded-xl transition-all hover:shadow-xl flex items-center justify-center gap-3"
                            >
                                Оформить заказ
                                <IoArrowForward className="text-xl" />
                            </button>
                        </Link>
                        <button
                            onClick={clearCart}
                            className="w-full py-3 text-white/60 hover:text-white border border-white/20 hover:border-white/40 rounded-xl transition"
                        >
                            Очистить корзину
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Cart;